import React from 'react';
import { FaBuilding, FaLayerGroup, FaInfoCircle } from 'react-icons/fa';
import { formatMoney, formatNum } from '../../../services/cadastral.service';
import { CONSTRUCTION_TYPES, CONSERVATION_STATES } from '../../../data/catalogs.constants';
import styles from '../../../styles/Cadastral.module.css';

function Block({ title, icon: Icon, children }) {
  return (
    <div className={styles.block}>
      <div className={styles.blockTitle}>
        <span className={styles.btIco}><Icon size={13} /></span>
        {title}
      </div>
      {children}
    </div>
  );
}

export default function ConstructionTab({ file }) {
  if (!file.buildings || !file.buildings.length) {
    return (
      <div className={styles.stateEmpty}>
        <div className={`${styles.stateIco} ${styles.idle}`}>
          <FaBuilding size={28} />
        </div>
        <h3>Sin construcciones registradas</h3>
        <p>El padrón catastral no reporta superficie de construcción para este predio.</p>
      </div>
    );
  }

  /* Summary by floor */
  const floorSummary = {};
  file.buildings.forEach(construction => {
    floorSummary[construction.level] = floorSummary[construction.level] || { surfaceArea: 0, value: 0, count: 0 };
    floorSummary[construction.level].surfaceArea += construction.area;
    floorSummary[construction.level].value += construction.totalValue;
    floorSummary[construction.level].count++;
  });

  return (
    <div className={styles.tabContentFade}>
      <Block title="B) Registro de construcciones" icon={FaBuilding}>
        <p className={styles.formula}>
          Valor de las Construcciones = Superficie × Valor Unitario × Factor de estado de conservación
        </p>
        <div className={styles.tblWrap}>
          <table className={styles.tbl}>
            <thead>
              <tr>
                <th className={styles.c}>Nivel</th>
                <th>Tipo</th>
                <th>Descripción</th>
                <th className={styles.c}>Estado de conservación</th>
                <th className={styles.r}>Superficie m²</th>
                <th className={styles.r}>Valor unitario</th>
                <th className={styles.c}>Factor</th>
                <th className={styles.r}>Valor</th>
              </tr>
            </thead>
            <tbody>
              {file.buildings.map((construction, index) => (
                <tr key={index}>
                  <td className={styles.c}>{construction.level}</td>
                  <td><span className={styles.typePill}>{construction.type}</span></td>
                  <td>{CONSTRUCTION_TYPES[construction.type]?.desc || 'Construcción'}</td>
                  <td className={styles.c}>
                    <span className={`${styles.conditionBadge} ${styles['condition' + construction.status]}`}>
                      {construction.status} · {CONSERVATION_STATES[construction.status]?.desc}
                    </span>
                  </td>
                  <td className={styles.r}>{formatNum(construction.area)}</td>
                  <td className={styles.r}>{formatMoney(construction.unitValue)}</td>
                  <td className={styles.c}>{construction.factor.toFixed(2)}</td>
                  <td className={styles.r}>{formatMoney(construction.totalValue)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={4}>TOTAL</td>
                <td className={styles.r}>{formatNum(file.totalBuildingArea)}</td>
                <td colSpan={2}>SUBTOTAL</td>
                <td className={styles.r}>{formatMoney(file.totalBuildingValue)}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </Block>

      <Block title="Resumen por nivel" icon={FaLayerGroup}>
        <div className={styles.tblWrap}>
          <table className={styles.tbl}>
            <thead>
              <tr>
                <th>Nivel</th>
                <th className={styles.c}>Partidas</th>
                <th className={styles.r}>Superficie m²</th>
                <th className={styles.r}>Valor</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(floorSummary).map(([floor, summary]) => (
                <tr key={floor}>
                  <td>N I V E L &nbsp;0{floor}</td>
                  <td className={styles.c}>{summary.count}</td>
                  <td className={styles.r}>{formatNum(summary.surfaceArea)}</td>
                  <td className={styles.r}>{formatMoney(summary.value)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Block>

      <Block title="Lineamientos de estado de conservación" icon={FaInfoCircle}>
        <div className={styles.tblWrap}>
          <table className={styles.tbl} style={{ minWidth: 0 }}>
            <thead>
              <tr>
                <th className={styles.c}>Clave</th>
                <th>Estado de conservación</th>
                <th className={styles.c}>Factor</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(CONSERVATION_STATES).map(([stateKey, conditionState]) => (
                <tr key={stateKey}>
                  <td className={styles.c}>
                    <span className={`${styles.conditionBadge} ${styles['condition' + stateKey]}`}>{stateKey}</span>
                  </td>
                  <td>{conditionState.desc}</td>
                  <td className={styles.c}>{conditionState.factor.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Block>
    </div>
  );
}